/**
 * Class representing language data
 */
export class Language {
  /**
   * Create language data.
   * @param {object} options - the language options to construct the language object
   * @param {String} countryIsoCode - the country iso code
   * @param {Number} id - the id of the country
   * @param {String} languageIsoCode - the language of the country
   * @param {Number} title - string presenting in which language content will be presented
   */
  constructor (options) {
    this.countryIsoCode = options.countryIsoCode
    this.id = options.id
    this.languageIsoCode = options.languageIsoCode
    this.title = options.title
  }

  get countryIsoCode () {
    return this._countryIsoCode
  }

  set countryIsoCode (value) {
    if (value) this._countryIsoCode = String(value)
    else this._countryIsoCode = null
  }

  get id () {
    return this._id
  }

  set id (value) {
    if (value) this._id = Number(value)
    else this._id = null
  }

  get languageIsoCode () {
    return this._languageIsoCode
  }

  set languageIsoCode (value) {
    if (value) this._languageIsoCode = String(value)
    else this._languageIsoCode = null
  }

  get title () {
    return this._title
  }

  set title (value) {
    if (value) this._title = String(value)
    else this._title = null
  }

  toJSON () {
    return {
      countryIsoCode: this._countryIsoCode,
      id: this._id,
      languageIsoCode: this._languageIsoCode,
      title: this._title
    }
  }
}
